import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './auth/ProtectedRoute';
import Login from './pages/LoginPage';
import Signup from './pages/SignupPage';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

const HomePage = lazy(() => import('./pages/homepage/HomePage'));
const About = lazy(() => import('./pages/AboutPage'));
const FeedPage = lazy(() => import('./pages/FeedPage'));
const GalleryPage = lazy(() => import('./pages/GalleryPage'));
const EditorPage = lazy(() => import('./pages/EditorPage'));
const ArtworkPage = lazy(() => import('./pages/ArtworkPage'));
const Users = lazy(() => import('./pages/Users'));
const Galleries = lazy(() => import('./pages/gallery/Galleries'));
const GalleryConfigAdmin = lazy(() => import('./pages/GalleryConfigAdmin'));
const WelcomeMessage = lazy(() => import('./pages/WelcomeMessage'));
const GalleryManagement = lazy(() => import('./pages/gallery/GalleryManagement'));
const Settings = lazy(() => import('./pages/Settings'));
const UserSettings = lazy(() => import('./pages/UserSettings'));
const BioPage = lazy(() => import('./pages/BioPage'));
const BlogPage = lazy(() => import('./pages/BlogPage'));
const AdminBlogPage = lazy(() => import('./pages/AdminBlogPage'));
const ViewBlogPage = lazy(() => import('./pages/ViewBlogPage'));
const AllArtworksPage = lazy(() => import('./pages/AllArtworksPage'));
const ArtozpherePage = lazy(() => import('./pages/artozphere/ArtozpherePage'));
const ArtozphereArtworkDetail = lazy(() => import('./pages/artozphere/ArtozphereArtworkDetail'));
const ArtworkStock = lazy(() => import('./pages/artozphere/ArtworkStock'));
const ArtozphereCart = lazy(() => import('./components/artozphere/ArtozphereCart'));
const ArtozphereCheckout = lazy(() => import('./components/artozphere/ArtozphereCheckout'));
const ArtozphereCheckoutSuccess = lazy(() => import('./components/artozphere/ArtozphereCheckoutSuccess'));

const RouteFallback = () => (
  <div className="flex min-h-screen items-center justify-center bg-gray-50">
    <div
      className="h-10 w-10 animate-spin rounded-full border-2 border-gray-300 border-t-gray-900"
      aria-label="Loading"
    />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/" element={<HomePage preview />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/about" element={<About />} />

          <Route element={<ProtectedRoute />}>
            <Route path="/home" element={<FeedPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/editor" element={<EditorPage />} />
            <Route path="/users" element={<Users />} />
            <Route path="/galleries" element={<Galleries />} />
            <Route path="/gallery-config" element={<GalleryConfigAdmin />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/user-settings" element={<UserSettings />} />
            <Route path="/gallery-management/:id" element={<GalleryManagement />} />
            <Route path="/artwork/:id" element={<ArtworkPage />} />
            <Route path="/artozphere" element={<ArtozpherePage />} />
            <Route path="/artozphere/cart" element={<ArtozphereCart />} />
            <Route path="/artozphere/checkout" element={<ArtozphereCheckout />} />
            <Route path="/artozphere/success" element={<ArtozphereCheckoutSuccess />} />
            <Route path="/artozphere/artwork/:artworkId/stocks" element={<ArtworkStock />} />
            <Route path="/artozphere/artwork/:artworkId" element={<ArtozphereArtworkDetail />} />
            <Route path="/bio" element={<BioPage />} />
            <Route path="/welcome" element={<WelcomeMessage />} />
            <Route path="/admin/blogs" element={<AdminBlogPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:id" element={<ViewBlogPage />} />
            <Route path="/all-artworks" element={<AllArtworksPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
